// styles
import styles from './picto-item.module.scss';

// types
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';

// components
import { Headline } from 'components/ContentElementsGdds/headline/headline';
import { InnerHtml } from 'components/InnerHtml/inner-html';
import { Image } from 'components/image/image';

// utils
import { useIsMobile } from 'components/App/SizeProvider';
import { responsiveImage } from 'utils/responsiveImage';
import { classNameBuilder } from 'utils/classNameBuilder';
import { useGroup } from 'utils/hooks/use-group';

export type PictoItemProps = {
  headline: string;
  imageAlt: string;
  imageObject: ImageObjectType;
  imageObjectMobile: ImageObjectType;
  description?: string;
  previewId?: string;
  reducedMobileVersion?: boolean;
  childOf?: string;
};

export function PictoItem({
  headline,
  description,
  imageAlt,
  imageObject,
  imageObjectMobile,
  reducedMobileVersion,
  childOf,
}: Readonly<PictoItemProps>) {
  const isMobile = useIsMobile();
  const isGroup = useGroup();
  const image = responsiveImage(isMobile, imageObjectMobile, imageObject);
  const showDescription = !(isMobile && reducedMobileVersion);

  return (
    <div
      className={classNameBuilder(
        styles['picto-item'],
        !showDescription && styles['no-description'],
      )}
    >
      {imageObject && (
        <Image
          data={image as ImageObject}
          alt={imageAlt}
          title={imageAlt}
          className={styles['picto-item-icon']}
        />
      )}
      {headline && (
        <Headline
          title={headline}
          tag={
            !isGroup && childOf && ['tab', 'accordion'].includes(childOf) ? Formats.h5 : Formats.h3
          }
          variant={Formats.h3}
          className={styles['picto-item-headline']}
        />
      )}
      {showDescription && description && <InnerHtml as="p" content={description} isGdds />}
    </div>
  );
}
